<script>
    import Fa from 'svelte-fa';
    import { faTag, faTags, faClose } from '@fortawesome/pro-regular-svg-icons';

    import { formatMoney } from '$lib/utils/functions/money.js';

    import Accordian from '$lib/components/Accordian.svelte';
    import AccordianItem from '$lib/components/AccordianItem.svelte';

    export let cartUpdating;
    export let discountCodes;
    export let cartCost;

    // Update Discount Code Mutation
    async function updateDiscountCodes(newCodeArray) {
        cartUpdating = true;
        cartUpdating = await window.cart.updateCartDiscountCodes(newCodeArray); // function returns false
        discountCodeToAdd = '';
    }
    // Remove Discount Code
    const removeDiscountCode = (codeToRemove) => {
        const removeCodeArray = discountCodes.map((discount) => discount?.code).filter((code) => code !== codeToRemove);
        updateDiscountCodes(removeCodeArray);
    };

    // Add Discount Code
    let discountCodeToAdd;
    const addDiscountCode = (codeToAdd) => {
        let addCodeArray = discountCodes.map((discount) => discount?.code);
        addCodeArray.push(codeToAdd);
        updateDiscountCodes(addCodeArray);
    };

    // Check if at least one discount code is active in cart.
    $: isDiscountCodeActive = discountCodes.some((discount) => discount.applicable);
</script>

<Accordian>
    <AccordianItem key="promoCode">
        <div slot="header" class="border-b border-t border-color-text/20 p-4">
            <Fa icon={faTags} class="mr-2 inline-block {isDiscountCodeActive ? 'text-primary dark:text-purple-300' : ''}" />
            Discounts
            {#if cartCost?.savings > 0 || cartCost?.compareAtSavings > 0}
                <span class="ml-1 inline-block rounded-md bg-color-text px-2 py-0.5 text-sm font-semibold text-base-900 opacity-90">
                    You've Saved {formatMoney((Number(cartCost?.savings) || 0) + (Number(cartCost?.compareAtSavings) || 0))}
                </span>
            {/if}
        </div>
        <div slot="body" class="flex flex-col gap-4 pt-4">
            {#if isDiscountCodeActive}
                <div class="flex flex-wrap gap-2">
                    {#each discountCodes as discountCode (discountCode)}
                        {#if discountCode?.applicable}
                            <div class="rounded-lg bg-base-700 p-1 text-xs font-semibold">
                                <Fa icon={faTag} class="mx-1 inline-block dark:text-purple-300" />
                                {discountCode?.code}
                                <button aria-label="Remove Discount Code" on:click={() => removeDiscountCode(discountCode?.code)}>
                                    <Fa icon={faClose} class="mx-1 inline-block" />
                                </button>
                            </div>
                        {/if}
                    {/each}
                </div>
            {/if}
            <form class="flex flex-row items-center gap-2" on:submit|preventDefault={() => addDiscountCode(discountCodeToAdd)}>
                <input
                    class="w-full grow rounded-xl border border-color-text/10 bg-base-900 px-4 py-3 text-base text-color-text shadow-sm outline-none focus:ring-0"
                    bind:value={discountCodeToAdd}
                    type="text"
                    name="discount"
                    placeholder="Enter discount code"
                    aria-label="Enter Discount Code"
                    autocomplete="off"
                />
                <button
                    class="rounded-xl bg-gray-800 px-4 py-3.5 text-sm font-semibold text-white dark:bg-base-800"
                    aria-label="Apply Discount Code"
                    type="submit"
                >
                    Apply
                </button>
            </form>
        </div>
    </AccordianItem>
</Accordian>
